import { useEffect, useRef, useState } from "react"
import { IoSearch } from "react-icons/io5"
import { MdClose, MdLocationPin } from "react-icons/md"
import { useSearchParams } from "react-router-dom"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"
import { capitalize } from "lodash-es"

import {
  TDeviceType,
  useDeviceTypeByWidth,
} from "@fuse/customHooks/useDeviceTypeByWidth"

import {
  DateRangeWithName,
  TDateRangeWithName,
  TExploreSearchArgs,
} from "@fuse/pages/explore"
import DropDown from "@fuse/pages/explore/component/DropDown"
import Tag from "@fuse/pages/explore/component/Tag"
import {
  fetchIpAndInfo,
  getTheLocationInfo,
  getThePreciseLocation,
  usePredictionAutocomplete,
} from "@fuse/pages/explore/utility/locationFunctions"

const SideBar = ({
  isVisible = false,
  closeSideBar,
  selectedList,
  setSearchArgs,
  searchArgs,
  whatsToFocus,
}) => {
  const [locationSearch, setLocationSearch] = useState<string>("")
  const { predictionList, fetchPlaceDetails } = usePredictionAutocomplete({
    locTerm: locationSearch,
    isSessionRequired: true,
  })

  const dropDownRef = useRef(null)
  const dateRangeRef = useRef(null)
  const locationRefBlock = useRef(null)

  useEffect(() => {
    if (whatsToFocus && isVisible) {
      switch (whatsToFocus) {
        case "locationComp":
          if (dropDownRef.current) {
            dropDownRef.current?.focus()

            setTimeout(() => {
              locationRefBlock.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }, 300)
          }
          return
        case "dateRangeComp":
          if (dateRangeRef.current) {
            dateRangeRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            })
          }
          return
      }
    }
  }, [whatsToFocus, isVisible])

  const [sideBarLocalFilterState, setsideBarLocalFilterState] =
    useState<TExploreSearchArgs>({
      location: {
        lon: 0,
        lat: 0,
        nameOfPlace: "",
      },
      searchTerm: "",
      tags: [],
      dateRangeType: DateRangeWithName.THIS_WEEK.value,
    })
  const [localSelectedList, setLocalSelectedList] = useState({})

  const handleApply = () => {
    closeSideBar(localSelectedList)
    setSearchArgs(sideBarLocalFilterState)
  }

  useEffect(() => {
    setLocalSelectedList(selectedList)
  }, [selectedList])

  const sidebarRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        closeSideBar()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const detailSetter = (data) => {
    setsideBarLocalFilterState((prev) => ({
      ...prev,
      ...data,
    }))

    if (isOnLoad) {
      setRootValueOnLoad(data)
      setIsOnLoad(false)
    }
  }

  const [searchParams, _] = useSearchParams()
  const timeRef = useRef(null)
  const setTheLocationName = async ({ lat, lon }) => {
    const name = await getTheLocationInfo({
      latitude: lat,
      longitude: lon,
    })

    detailSetter({
      location: {
        lat,
        lon,
        nameOfPlace: name,
      },
    })
  }

  const setRootValueOnLoad = (data) => {
    if (isOnLoad) {
      setSearchArgs((prev) => ({
        ...prev,
        ...data,
      }))
      setIsOnLoad(false)
    }
  }

  const [isOnLoad, setIsOnLoad] = useState(true)

  useEffect(() => {
    const [lat, lon] =
      Array.from(searchParams.keys()).includes("location") &&
      searchParams.get("location").split(",").length == 2
        ? searchParams.get("location").split(",")
        : [0, 0]

    const dataRangeInitializationValFromUrl = Array.from(
      searchParams.keys(),
    ).includes("dateRangeType")
      ? (searchParams.get("dateRangeType") as TDateRangeWithName)
      : ""

    if (dataRangeInitializationValFromUrl) {
      const expectedVal = [
        DateRangeWithName.NEXT_WEEK.value,
        DateRangeWithName.THIS_MONTH.value,
        DateRangeWithName.THIS_WEEK.value,
      ]
      if (expectedVal.includes(dataRangeInitializationValFromUrl)) {
        setsideBarLocalFilterState((prev) => {
          return {
            ...prev,
            dateRangeType: dataRangeInitializationValFromUrl,
          }
        })
      }
    }

    if (lat && lon) {
      setTheLocationName({
        lat: lat,
        lon: lon,
      })
    } else {
      if (timeRef.current) {
        clearTimeout(timeRef?.current)
      } else {
        timeRef.current = setTimeout(() => {
          if (!searchArgs?.location?.nameOfLocation) {
            fetchIpAndInfo(detailSetter)
          }
        }, 1000)
      }
    }
  }, [])

  useEffect(() => {
    const tagArr: string[] = []
    Object.keys(localSelectedList).forEach((item: string) => {
      if (localSelectedList[item]) {
        tagArr.push(item.toString())
      }
    })

    setsideBarLocalFilterState((prev) => {
      return {
        ...prev,
        tags: tagArr,
      }
    })
  }, [localSelectedList])

  useEffect(() => {
    if (isVisible) {
      document.body.style.pointerEvents = "none"
    } else {
      document.body.style.pointerEvents = "auto"
    }
  }, [isVisible])

  const deviceType = useDeviceTypeByWidth() //TDeviceType

  if (!isVisible) return
  return (
    // <div
    //   className={`absolute w-full h-full overflow-hidden  ${isVisible ? "animate-slide-in-right " : "animate-slide-out-right "} `}
    //   // ref={masterContainerRef}
    // >
    <div
      className={` overflow-hidden fixed right-0 pointer-events-auto  flex flex-col justify-between  h-full bg-[#252525D1]  w-[60%] sm:w-[50%]  md:w-[40%] lg:w-[35%] xl:w-[30%] ${deviceType === TDeviceType.MOBILE ? "!w-[100%] !h-[80%] rounded-t-3xl !bottom-0" : ""}`}
      ref={sidebarRef}
      style={{ backdropFilter: "blur(10px)" }}
    >
      {/* header */}
      <div className=" h-full  overflow-auto">
        {/* content */}
        {/* <div> */}
        {/*  remove the above comment  to scrolll the filter tag up when the
        list is scroll */}
        <div className=" border-b-2 sticky top-0 py-5 backdrop-blur-md bg-[#00000080] border-[#FFFFFF33] px-6">
          <div className="flex justify-between items-center ">
            <div className="font-semibold text-xl text-white hover:cursor-default">
              Filter
            </div>
            <div
              onClick={() => closeSideBar()}
              className="hover:cursor-pointer"
            >
              <MdClose fill="white" size={20} />
            </div>
          </div>
        </div>
        {/* </div> */}
        <div className="bg-[tranparent] px-6 ">
          <div className="w-full flex justify-between ">
            <div className="text-[#ffffffff] py-2 hover:cursor-default">
              Interest
            </div>
            <div
              className="text-[#ffffff80] py-2 hover:cursor-pointer "
              onClick={() => {
                const newValue = {}
                Object.keys(localSelectedList).forEach((item) => {
                  newValue[item] = false
                })
                setLocalSelectedList(newValue)
              }}
            >
              Reset
            </div>
          </div>
          {
            <div className="flex flex-wrap ">
              {Object.keys(localSelectedList).map((item, _) => {
                return (
                  <div key={_}>
                    <Tag
                      isSelected={localSelectedList[item]}
                      tagTitle={capitalize(item)}
                      onClick={() =>
                        setLocalSelectedList((prev) => ({
                          ...prev,
                          [item]: !localSelectedList[item],
                        }))
                      }
                    />
                  </div>
                )
              })}
            </div>
          }
        </div>
        {/* location */}
        <div
          className=" border-t-2 border-[#FFFFFF33] my-4 mx-6 "
          ref={locationRefBlock}
        >
          <div className="w-full flex justify-between ">
            <div className="text-[#ffffffff] py-2 hover:cursor-default">
              Location
            </div>
            <div
              className="text-[#ffffff80] py-2 hover:cursor-pointer "
              onClick={() => {
                setLocationSearch("")
                setsideBarLocalFilterState((prev) => ({
                  ...prev,
                  location: {
                    lat: 0,
                    lon: 0,
                    nameOfPlace: "",
                  },
                }))
              }}
            >
              Reset
            </div>
          </div>

          <div className={`flex bg-[#7F7F7F33] rounded-xl   w-full  `}>
            <DropDown
              onChangeVal={(val) => {
                setLocationSearch(val)
              }}
              valueOfState={sideBarLocalFilterState?.location?.nameOfPlace}
              searchTermvalue={locationSearch}
              ref={dropDownRef}
              list={[
                {
                  icon: <IoSearch color="#ffffff80" size={20} />,
                  title: "Detect the location",
                  subTitle: "Using GPS",
                  onClick: () => getThePreciseLocation(detailSetter),
                },

                ...predictionList.map((item) => {
                  return {
                    icon: <MdLocationPin color="#ffffff80" size={20} />,
                    title: item?.description,
                    onClick: () => {
                      fetchPlaceDetails(item?.place_id)
                        .then((res) => detailSetter(res))
                        .catch((err) => console.warn(err))
                      setLocationSearch("")
                    },
                  }
                }),
              ]}
            />
          </div>
        </div>
        {/* date range */}
        <div
          className=" border-t-2 border-[#FFFFFF33] my-4 mx-6"
          ref={dateRangeRef}
        >
          <div className="w-full flex justify-between ">
            <div className="text-[#ffffffff] py-2 ">Date</div>
          </div>

          <div className="flex flex-wrap">
            <Tag
              isSelected={
                sideBarLocalFilterState?.dateRangeType ===
                DateRangeWithName?.THIS_WEEK?.value
              }
              tagTitle={DateRangeWithName?.THIS_WEEK?.title}
              onClick={() => {
                setsideBarLocalFilterState((prev) => {
                  return {
                    ...prev,
                    dateRangeType: DateRangeWithName?.THIS_WEEK?.value,
                  }
                })
              }}
            />
            <Tag
              isSelected={
                sideBarLocalFilterState?.dateRangeType ===
                DateRangeWithName?.NEXT_WEEK?.value
              }
              tagTitle={DateRangeWithName?.NEXT_WEEK?.title}
              onClick={() => {
                setsideBarLocalFilterState((prev) => {
                  return {
                    ...prev,
                    dateRangeType: DateRangeWithName?.NEXT_WEEK?.value,
                  }
                })
              }}
            />
            <Tag
              isSelected={
                sideBarLocalFilterState?.dateRangeType ===
                DateRangeWithName?.THIS_MONTH?.value
              }
              tagTitle={DateRangeWithName?.THIS_MONTH?.title}
              onClick={() => {
                setsideBarLocalFilterState((prev) => {
                  return {
                    ...prev,
                    dateRangeType: DateRangeWithName?.THIS_MONTH?.value,
                  }
                })
              }}
            />
          </div>
        </div>
      </div>

      {/* button */}
      <div className="flex gap-4  px-8   py-4">
        <Button onClick={handleApply} className="w-full">
          Apply
        </Button>
      </div>
    </div>
    // </div>
  )
}

export default SideBar
